import type {
  SlotAwareField,
  WalkSlotAwareFieldOptions
} from '@cli-types/core-engine/schema-reader.js'
import { flattenSlotLayout } from '@core-engine/schema/slot-layout/flatten-slot-layout.js'

export function walkSlotAwareField(
  field: SlotAwareField,
  fieldPath: string,
  errors: string[],
  options: WalkSlotAwareFieldOptions
): void {
  options.checkField(field, fieldPath, errors)

  const descend = (children: SlotAwareField[], parentPath: string): void => {
    for (const child of children) {
      walkSlotAwareField(child, `${parentPath}.${child.name ?? 'unnamed'}`, errors, options)
    }
  }

  if (field.fields) {
    descend(field.fields, fieldPath)
  }

  if (field.tabs) {
    for (const tab of field.tabs) {
      const tabPath = `${fieldPath}.${tab.name ?? 'unnamed'}`
      options.onTab?.(tab, tabPath, errors)

      if (options.descendTabSlots && tab.slot !== undefined) {
        descend(flattenSlotLayout(tab.slot), tabPath)
      }

      if (tab.fields) {
        descend(tab.fields, tabPath)
      }
    }
  }
}
